import React, { useState, useEffect } from "react"
import { getTariffaFissa } from "../../../services/endpoints";
import { showProgress, moveFocusTo } from "../../../utils/elements";
import { getTipoVeicoloLeggibile } from "../../../utils/utilities"
import * as Constants from "../../../utils/constants"
import {
  Container,
  Row,
  Col,
  Button,
  Modal,
  ModalHeader,
  ModalFooter,
  ModalBody,
} from 'design-react-kit';

export const SibaMostraCalcoloFisso = ({ targa, tipoVeicolo, handleDataLoaded, handleBack, handleNext }) => {

  const [isModaleVisibile, setModaleVisibile] = useState(true);
  const [isLoading, setLoading] = useState(true);
  const [calcolo, setCalcolo] = useState({});
  const [targaNonValida,setTargaNonValida] = useState(false);

  useEffect(() => {
    const loadTariffa = async () => {
      
      if(tipoVeicolo === Constants.TIPO_VEICOLO_CICLOMOTORE || 
         tipoVeicolo === Constants.TIPO_VEICOLO_QUADRICICLO_LEGGERO){
          if((targa.length < Constants.LUNGHEZZA_MIN_NUM_TELAIO) || (targa.length > Constants.LUNGHEZZA_MAX_NUM_TELAIO)) {    //STALIGK-860
            setTargaNonValida(true);
          }
      }


      const responseTariffaFissa = await getTariffaFissa(tipoVeicolo)
      console.log("responseTariffaFissa", responseTariffaFissa)
      if (responseTariffaFissa === undefined) {
        console.log('Calcolo fallito per tipo veicolo %s', tipoVeicolo)
        setLoading(false)
        return
      }
      handleDataLoaded({ "datiPagamento": responseTariffaFissa, "scenarioAlternativo": tipoVeicolo });
      setCalcolo(responseTariffaFissa)
      setLoading(false)
    }
    loadTariffa();
  }, []);

  useEffect(() => {
    if (isModaleVisibile) {
      moveFocusTo("modale_ok");
    } else {
      moveFocusTo("conferma_calcolo");
    }
  });

  const onSubmit = () => handleNext()
  const handleClose = () => { setModaleVisibile(false); }
  const getTotale = () => { return (calcolo.importo.tassa.importo + calcolo.importo.sanzioni.importo + calcolo.importo.interessi.importo).toFixed(2); }

  //START RENDERING
  if (isLoading) { return showProgress() }

  return (
    <Container className="px-2 my-2" id="calcoloFisso1" tag="section">
      <Container className="px-2 my-2" id="calcoloFisso2" tag="section">
        <Modal isOpen={isModaleVisibile} popConfirm style={{ maxWidth: "50%" }}>
          <ModalHeader charCode={215} closeAriaLabel="Close" tag="h5" wrapTag="div" >
            ATTENZIONE
          </ModalHeader>
          <ModalBody tag="div">
          Il pagamento del bollo che stai per effettuare sar&agrave; valido fino a:&nbsp;<br />
            <strong>{calcolo.dataScadenza.mese.descrizione} {calcolo.dataScadenza.anno}</strong> <br />
            (incluso)
          </ModalBody>
          <ModalFooter tag="div">
            <Button
              className="btn btn-outline-primary"
              onClick={handleBack}
            > Torna indietro
            </Button>
            <Button
              id="modale_ok"
              className="btn btn-primary"
              color="primary"
              onClick={handleClose}
            > OK
            </Button>
          </ModalFooter>
        </Modal>
      </Container>
      <Row>
        <Col>
          <h4>Riepilogo dati calcolo fisso</h4>
          <table className="table table-striped table-sm">
            <tbody>
              <tr>
                <th>Targa</th>
                <td>{targa}</td>
              </tr>
              <tr>
                <th>Tipo veicolo</th>
                <td>{getTipoVeicoloLeggibile(tipoVeicolo)}</td>
              </tr>
              <tr>
                <th>Bollo valido fino a</th>
                <td>{calcolo.dataScadenza.mese.descrizione} {calcolo.dataScadenza.anno}</td>
              </tr>
              <tr>
                <th>Validit&agrave;</th>
                <td>{calcolo.validita} mesi</td>
              </tr>
              <tr>
                <th>Importo</th>
                <td><strong>{getTotale(calcolo)}</strong> {calcolo.importo.tassa.divisa.descrizione}</td>
              </tr>
              <tr>
                <th>Parametri calcolo</th>
                <td>{calcolo.esplicativo}</td>
              </tr>
            </tbody>
          </table>
        </Col>
      </Row>
      {targaNonValida ? <div><strong>Non è possibile procedere al pagamento perchè la targa inserita non corrisponde ad un telaio</strong></div> : 
      <Button id="conferma_calcolo" className="btn btn-primary" color="primary" size="sm" icon={false} tag="button" onClick={onSubmit} >
        {/* STALIGK-834 Procedi al pagamento */}Avanti
      </Button> }
    </Container>
  )
}

export default SibaMostraCalcoloFisso;